/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaching_ChatInputs */

const en_us2_coaching_chat = /** @type {(inputs: Coaching_ChatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Message`)
};

const pt_br2_coaching_chat = /** @type {(inputs: Coaching_ChatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversar`)
};

const pt_pt2_coaching_chat = /** @type {(inputs: Coaching_ChatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversar`)
};

/** @type {(inputs: Coaching_ChatInputs) => LocalizedString} */
const es_419_coaching_chat = en_us2_coaching_chat;

/** @type {(inputs: Coaching_ChatInputs) => LocalizedString} */
const fr_fr2_coaching_chat = en_us2_coaching_chat;

/** @type {(inputs: Coaching_ChatInputs) => LocalizedString} */
const de_de2_coaching_chat = en_us2_coaching_chat;

/** @type {(inputs: Coaching_ChatInputs) => LocalizedString} */
const it_it2_coaching_chat = en_us2_coaching_chat;

/**
* | output |
* | --- |
* | "Message" |
*
* @param {Coaching_ChatInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coaching_chat = /** @type {((inputs?: Coaching_ChatInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_ChatInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coaching_chat(inputs)
	if (locale === "es-419") return es_419_coaching_chat(inputs)
	if (locale === "pt-PT") return pt_pt2_coaching_chat(inputs)
	if (locale === "fr-FR") return fr_fr2_coaching_chat(inputs)
	if (locale === "de-DE") return de_de2_coaching_chat(inputs)
	if (locale === "it-IT") return it_it2_coaching_chat(inputs)
	return en_us2_coaching_chat(inputs)
});
export { coaching_chat as "coaching.chat" }